import { Component, State, h, ComponentInterface, Prop } from "@stencil/core";
import { AppHomeType } from '../app-home/app-home-types';

@Component({
  tag: "app-landing",
  styleUrl: "app-landing.css"
})
export class AppLanding implements ComponentInterface {
  @Prop() firmType: AppHomeType;

  renderNavBar() {
    return (<ion-header></ion-header>);
  }

  render() {
    return (
      <div id="landing" class="block-container landing-container">
        <div id="landing-inner" class="landing-inner-container">
          <div class="block landing-block landing-block-1">

            <ion-grid class="ion-no-padding">
              <ion-row class="ion-nowrap">
                <ion-img class="ion-float-start ion-margin-end ion-margin-top" src="/assets/svg/logo-vertical-menor.svg" alt="logo-pager-online" />
              </ion-row>
              <ion-row class="ion-nowrap">
                {/* <ion-img class="landing-img-icon ion-float-start ion-margin-end ion-margin-top" src="/assets/img/icon.png" alt="logo-pager-online" /> */}
                <ion-text color="dark">
                  {/* <h1 class="landing-title cristal-text-shadow">
                    Aplicativo Chamador de Pager
                  </h1> */}
                  {/* <h1 class="landing-title cristal-text-shadow">
                    Aplicativo Chamador de Pager
                  </h1>                   */}
                  {/* <h2 class="landing-sub-title cristal-text-shadow">
                    Chamador de Pager Para Celular, Tablet ou Web
                  </h2> */}
                </ion-text>
              </ion-row>
            </ion-grid>
            <ion-text color="dark">
              <h2 class="landing-list cristal-text-shadow">
                {this.firmType === AppHomeType.restaurante ?
                  <ul>
                    <li class="ion-padding-bottom"><ion-text color="primary"><b>Você não precisa comprar aparelhos pager</b></ion-text></li>
                    <li class="ion-padding-bottom">Os clientes acompanham seu pager em tempo real direto do celular</li>
                    <li class="ion-padding-bottom">Os clientes são notificados para lembrarem de buscar o pedido</li>
                    <li>Envie o link do pager ou mensagens personalizadas {"pelo "}
                      <ion-text class="ion-text-nowrap" color="success">
                        <ion-icon name="logo-whatsapp" color="success"></ion-icon><b>{" Whatsapp"}</b>
                      </ion-text>
                    </li>
                    <li class="ion-padding-bottom">Controle os pagers diretamente do navegador de forma simples</li>
                  </ul> : null}
                  <h2 class="landing-price">
                    {<ion-text color="primary"><b>{'Por apenas R$ 99,00 mensais'}</b></ion-text>}
                    {/* {(this.moeda === 'euro') && 'Por apenas € 49,90 mensais'} */}
                  </h2>
              </h2>
              {/* <h2 class="landing-price">
                Por apenas R$ 99,00 mensais
              </h2> */}
              {/* <h2 class="landing-sub-title landing-sub-title-2 cristal-text-shadow">
                <ion-row class="ion-no-padding">
                  <ion-col class="ion-nowrap ion-text-nowrap">
                    <div> <ion-icon name="call" color="tertiary" /> (18)3624-8308</div>
                  </ion-col>
                  <ion-col class="ion-nowrap ion-text-nowrap">
                    <div> <ion-icon name="logo-whatsapp" color="success" />  (18)98123-6566{" "}</div>
                  </ion-col>
                </ion-row>
              </h2> */}
            </ion-text>
            <ion-grid class="ion-no-padding ion-padding-top">
              <ion-row class="ion-justify-content-between ion-align-items-center ion-margin-vertical ion-nowrap top-row-pad">
                <a class="landing-store-icon-link" href="https://pager-online.web.app">
                  <ion-img class="landing-store-icon" src="/assets/svg/versao-web.svg" alt="Versão Web" />
                </a>
              </ion-row>
            </ion-grid>
          </div>

          <div class="block landing-block landing-block-2">
            <ion-card>
              <ion-header>
                <ion-toolbar color="none">
                  <ion-icon slot="start" class="ion-padding-start" name="person-add"></ion-icon>
                  <div class="landing-cadastro-title">
                    <ion-title class="ion-padding-start" >Teste Grátis*</ion-title>
                    <div class="landing-cadastro-subtitle">*Até 10 dias OU no máximo 50 registros</div>
                  </div>
                </ion-toolbar>
              </ion-header>
              <div id="signup" class="landing-signup-form">
                <line-signup></line-signup>
              </div>
            </ion-card>
          </div>
        </div>
      </div>
    );
  }
}
